<template>
<div class="mini-cart">
    <button class="mini-cart__button" @click.prevent="toggle_details">
        <i class="fas fa-shopping-cart"></i>
        <span class="mini-cart__button__count">{{$store.state.site_data.session.cart.count}}</span>
    </button>
    <router-link v-if="!mini" class="mini-cart__link" to="/cart">
        <p class="subtitle">{{$store.state.site_data.session.cart.amount ? $store.state.site_data.session.cart.amount.toDollar() : (0).toDollar()}}</p>
        <p class="title">My Cart</p>
    </router-link>
</div>
</template>

<script>
export default {
    name        :   'MiniCart',
    props       :   ['mini'],
    methods     :   {
        toggle_details()
        {
            this.$bus.$emit('onToggleCart');
        }
    }
}
</script>



// WEBPACK FOOTER //
// src/components/blocks/elements/MiniCart.vue